import constants from "../constants";
import variables from "../variables";
import Link from "../../features/Link";
import {currentPlayer} from "../people/people";
import places from "./places";
import conditions from "../conditions";
import Place from "./Place";
import Image from "../../features/Image";
import images from "../images";
import missions from "../missions";
import {probabilityWorked} from "../features/functions";

class HomePlace extends Place {
    constructor(id="", name="", image="", description="") {
        super(id, name, image, description);
    }

    getDefaultLinks(links) {
        return (
            <div>
                {links.map((val, key) => {
                    if ((val.conditionCallBack && val.conditionCallBack()) || !val.conditionCallBack) {
                        return <div key={key}>
                            <Link style={val.style? val.style : {}} to={val.to ? val.to : ""} callback={val.goTo}>{val.linkName}</Link>
                        </div>
                    }
                })}
            </div>
        );
    };

    getImage() {return <Image src={images.places.homes[variables.game.home][this.id]}/>};

    getCaption() {return <h1>{constants.homes[variables.game.home].name} {this.name}</h1>};
}

const missionStyle = {color: "orange"};

const homeMain = new HomePlace("homeMain", "Main", "homeMain", `Main Hall of ${constants.homes[variables.game.home].name}. Old residential complex in a poor area of the city, where the cheapest apartments are rented.`);
homeMain.addBeforeEnteringCallback(()=>(!conditions.isDay()), "game.dontGoOutsideAtNight");
homeMain.addBeforeEnteringCallback(()=>(!conditions.isTimeForWork() && !variables.player.warnDidntGoToWork && currentPlayer.isPlayer()), "game.dontGoToWork");
homeMain.addBeforeEnteringCallback(()=>(currentPlayer.isWife() && !variables.wife.isDressedUp), "wife.dressUp");
homeMain.addDefaultLink("other.places.homeMain.work", "", ()=>{currentPlayer.goTo(places.courier.id)}, ()=>(conditions.isTimeForWork()));
homeMain.addDefaultLink("other.places.homeMain.goBuyPinaColada", "story.goBuyPinaColada", null, ()=>(conditions.missions.pinaColadaActive()), missionStyle);
homeMain.addDefaultLink("other.places.homeMain.wifeOfficeInterview", "story.wifeOfficeInterview", null, ()=>(conditions.missions.wifeGoesToInterviewInOffice()), missionStyle);
homeMain.addDefaultLink("other.places.homeMain.goHome", "", () =>{currentPlayer.goTo(places.homeBedroom.id)}, ()=>(!conditions.isDay02Start()));

const homeBedroom = new HomePlace("homeBedroom", "Bedroom", "homeBedroom", "There are a TV, parody of a desktop with a computer on it, as well as your bed.");
homeBedroom.addBeforeEnteringCallback(()=>(
    probabilityWorked(constants.player.probabilities.homeComingEvent) &&
        currentPlayer.isPlayer() &&
        !variables.game.randomEvents.homeWife), "homeEvents.main");
homeBedroom.addBeforeEnteringCallback(() => (!variables.game.day02.wentBackAfterHome), "day02.backHomeFromWork");
homeBedroom.addBeforeEnteringCallback(() => (conditions.missions.goHomeAfterWifeGotJob()), "story.goHome_01");
homeBedroom.addBeforeEnteringCallback(() => (currentPlayer.isWife() && variables.wife.isDressedUp), "wife.undress");
homeBedroom.addDefaultLink(
    variables.wife.name,
    "",
    () => {currentPlayer.goTo(places.wifeMenu.id)},
    ()=>(conditions.wifeIsHere(homeBedroom.id)),
    { color: "#e220d4" }
);
homeBedroom.addDefaultLink("other.places.homeBedroom.table", "", () => {currentPlayer.goTo(places.table.id)});
homeBedroom.addDefaultLink("other.places.homeBedroom.bed", "", ()=>{currentPlayer.goTo(places.bedMenu.id)}, ()=>(currentPlayer.isPlayer()))
homeBedroom.addDefaultLink("other.places.homeBedroom.kitchen", "", () => {currentPlayer.goTo(places.homeKitchen.id)});
homeBedroom.addDefaultLink("other.places.homeBedroom.bathroom", "", () => {currentPlayer.goTo(places.homeBathroom.id)});
homeBedroom.addDefaultLink("other.places.homeBedroom.outside", "", () => {currentPlayer.goTo(places.homeMain.id)});

const homeKitchen = new HomePlace("homeKitchen", "Kitchen", "homeKitchen", "Just an ordinary kitchen. Refrigerator, stove, microwave, stands for cooking. Nearby is a small table on which flowers flaunt.");
homeKitchen.addDefaultLink(
    variables.wife.name,
    "",
    () => {currentPlayer.goTo(places.wifeMenu.id)},
    ()=>(conditions.wifeIsHere(homeKitchen.id)),
    { color: "#e220d4" }
);
homeKitchen.addDefaultLink("other.places.homeKitchen.bottle", "story.treatWifePill_01kitchen", null, () => (conditions.missions.pillToPinaColada()), missionStyle);
homeKitchen.addDefaultLink("other.places.homeKitchen.bedroom", "", () =>{currentPlayer.goTo(places.homeBedroom.id)});

const homeBathroom = new HomePlace("homeBathroom", "Bathroom", "homeBathroom", "Your bathroom. Nothing special: sink, toilet, shower.");
homeBathroom.addBeforeEnteringCallback(()=>(conditions.wifeInBathroom() && !conditions.playerCanGoToBathroomWhenWifeIsThere()), "game.cantGoToBathroom");
homeBathroom.addDefaultLink(
    variables.wife.name,
    "",
    () => {currentPlayer.goTo(places.wifeMenu.id)},
    ()=>(conditions.wifeIsHere(homeBathroom.id)),
    { color: "#e220d4" }
);
homeBathroom.addDefaultLink("other.places.homeBathroom.bedroom", "", () =>{currentPlayer.goTo(places.homeBedroom.id)});
homeBathroom.addBeforeEnteringCallback(()=>(conditions.playerInBathroom()), "story.wifeIsGoingToBathroom");


const home = {
    homeMain,
    homeBedroom,
    homeKitchen,
    homeBathroom
};

export default home;